/** Tokens visuais — cupons (marca TNV) */
export const CUPONS_ACCENT = "#F96030";
export const CUPONS_INK = "#1a2035";

export const cuponsToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${CUPONS_ACCENT}`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 720,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  background: `linear-gradient(135deg, ${CUPONS_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${CUPONS_ACCENT}`,
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "grey.500",
    borderWidth: 1,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "text.secondary",
  },
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${CUPONS_ACCENT}, #e04a1a)`,
};
